import React from 'react'
import {verify} from '../features/auth/authSlice'
import {useState, useEffect, useRef} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import { useNavigate } from 'react-router-dom'

function VerifyUser (){
    // Use array for 6 digits
    const [codeDigits, setCodeDigits] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {user, isError, isSuccess, message, verified} = useSelector(state => state.auth)

    useEffect(()=>{
        if(isError){
            
            toast.error(verified)
            toast.error(message)
        }

        if(verified === "approved"){
            toast.success(" You are verified, welcome!", {
                position: toast.POSITION.TOP_CENTER
              });
            navigate('/homedash')
        }
        console.log(verified)


    },[isError,isSuccess,user, message, verified, navigate,dispatch])

    // Handle input for each digit
    const handleChange = (e, idx) => {
        const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 1);
        const newDigits = [...codeDigits];
        newDigits[idx] = val;
        setCodeDigits(newDigits);

        // Move to next input if value entered
        if (val && idx < 5) {
            inputRefs.current[idx + 1].current.focus();
        }
    };

    // Handle backspace to move focus
    const handleKeyDown = (e, idx) => {
        if (e.key === 'Backspace' && !codeDigits[idx] && idx > 0) {
            inputRefs.current[idx - 1].current.focus();
        }
    };

    const onSubmit = (e) =>{
        e.preventDefault()
        const code = codeDigits.join('');
        if(code.length !== 6){
            toast.error("Enter the 6-digit code received")
        }else{
            dispatch(verify({code}))
        }
    }

    return(
    <>
        <section className='heading px-4 md:px-0 flex flex-col items-center'>
            <h1 className="font-kanit text-xl text-charcoal mb-4 mt-4 text-center">
                Verification code
            </h1>
        </section>
        
        <div className="flex justify-center">
            <p className="text-gray-600 mb-6 text-sm ml-2 text-center">A 6-digit code was sent to your phone.</p>
        </div>

        <section className='form flex flex-col items-center px-4 py-8 md:px-0'>
            <form onSubmit={onSubmit} className="flex flex-col items-center gap-6">
                <div className="flex gap-3 mb-4">
                    {codeDigits.map((digit, idx) => (
                        <input
                            key={idx}
                            ref={inputRefs.current[idx]}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="w-12 h-12 text-center text-2xl font-bold rounded-lg border-2 border-robin bg-ivory text-charcoal focus:outline-none focus:border-orangem transition-all"
                            value={digit}
                            onChange={e => handleChange(e, idx)}
                            onKeyDown={e => handleKeyDown(e, idx)}
                            name={`code-${idx}`}
                            autoComplete="one-time-code"
                        />
                    ))}
                </div>
                <button className='btn btn-block bg-orangem text-ivory font-kanit px-6 py-2 rounded-lg hover:bg-robin transition-all'>
                    Submit
                </button>
            </form>
        </section>
    </>
    )
}

export default VerifyUser